export const queryKeys = {
  overview: ["overview"] as const,
  compileRuns: (params?: Record<string, unknown>) =>
    ["compile-runs", params] as const,
  compileRun: (id: string) => ["compile-runs", id] as const,
};
